import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region
import { Grid, Switch } from "@mui/material";
import { ToggleSwitchProps } from "models/propTypes/inputPropTypes";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { LocalizationHelperInstance } from "utils/helpers";

const ToggleSwitch: React.FC<ToggleSwitchProps> = (props) => {
  const { customLabels, ...switchProps } = props;
  let switchRef: HTMLButtonElement | null;

  React.useEffect(() => {
    return () => {
      switchRef = null;
    };
  }, []);

  const onLabelClick = () => {
    switchRef?.click();
  };

  return (
    <Grid item className={clsx(cssExports.switchContainer, switchProps.disabled ? cssExports.disable : "")}>
      {customLabels === undefined || (customLabels?.active && customLabels?.inactive) ? (
        <label
          className={clsx(cssExports.switchLabel, props.checked ? cssExports.checked : "", props.className)}
          onClick={onLabelClick}
        >
          {(props.checked
            ? customLabels
              ? customLabels.active
              : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Yes)
            : customLabels
            ? customLabels.inactive
            : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.No)
          ).toUpperCase()}
        </label>
      ) : (
        <></>
      )}
      <Switch
        {...switchProps}
        inputRef={(component: HTMLButtonElement) => (switchRef = component)}
        classes={{
          root: cssExports.switchRoot,
          switchBase: cssExports.switchBase,
          thumb: cssExports.thumb,
          track: cssExports.track,
          checked: cssExports.checked,
        }}
      />
    </Grid>
  );
};

export default ToggleSwitch;
